"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsCollectionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var ClaimsWidgetHelper_1 = require("./helper/ClaimsWidgetHelper");
var ClaimsCollectionWidget = /** @class */ (function (_super) {
    __extends(ClaimsCollectionWidget, _super);
    function ClaimsCollectionWidget(props) {
        return _super.call(this, props) || this;
    }
    ClaimsCollectionWidget.prototype.getParentObject = function () {
        return this.getSetting("parentObject");
    };
    ClaimsCollectionWidget.prototype.getParentObjExpr = function () {
        return this.getSetting("parentObjExpr");
    };
    ClaimsCollectionWidget.prototype.getClaims = function () {
        return this.bindFromField("".concat(this.getParentObject(), ".claims")) || [];
    };
    ClaimsCollectionWidget.prototype.getArrayExpression = function () {
        return this.getSetting("arrayExpression", false);
    };
    ClaimsCollectionWidget.prototype.getArrayIndex = function () {
        return this.getSetting("arrayIndex");
    };
    ClaimsCollectionWidget.prototype.buildQuestions = function () {
        var _this = this;
        var claims = this.getClaims();
        return claims.map(function (claim, index) {
            var _a;
            var group = new journey_model_1.Question();
            group.name = "claim_".concat((_a = claim === null || claim === void 0 ? void 0 : claim.selfDeclaredId) !== null && _a !== void 0 ? _a : index);
            group.label = "Claim No. ".concat(index + 1);
            group.type = "group";
            group.questions = ClaimsWidgetHelper_1.ClaimsWidgetHelper.claimContents(index, _this.getParentObject(), _this.getParentObjExpr(), _this.getArrayExpression(), _this.getArrayIndex());
            return group;
        });
    };
    ClaimsCollectionWidget.prototype.render = function () {
        var claims = this.getClaims();
        return ((0, jsx_runtime_1.jsx)("div", { className: "claims-collection-widget", children: (0, jsx_runtime_1.jsx)(plugin_journey_1.QuestionList, __assign({}, this.props, { questions: this.buildQuestions() }), claims.map(function (c) { return c.selfDeclaredId; }).join("-")) }));
    };
    ClaimsCollectionWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "parentObject", type: journey_model_1.TypeDescriptions.String },
            { name: "parentObjExpr", type: journey_model_1.TypeDescriptions.String },
            { name: "maxClaims", type: journey_model_1.TypeDescriptions.Number },
            { name: "arrayExpression", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "arrayIndex", type: journey_model_1.TypeDescriptions.Number }
        ]),
        __metadata("design:paramtypes", [Object])
    ], ClaimsCollectionWidget);
    return ClaimsCollectionWidget;
}(plugin_journey_1.WidgetBase));
exports.ClaimsCollectionWidget = ClaimsCollectionWidget;
//# sourceMappingURL=ClaimsCollectionWidget.js.map